module.exports = __webpack_public_path__ + "h5/img/record4.180c48e8.png";